import { navigate } from 'gatsby'
import React, { useEffect } from 'react'

const RedirectTemplate = ({
  location,
  destination,
  state = null,
  preserveQuery = true,
  loadingComponent = null,
  external = false,
}) => {
  useEffect(() => {
    const query = preserveQuery ? location.search : ''
    const targetUrl = destination + query

    if (external || destination?.startsWith('http')) {
      // External redirect - use window.location
      window.location.href = targetUrl
    } else {
      // Internal Gatsby navigation - can pass state
      if (state) {
        navigate(targetUrl, { state })
      } else {
        navigate(targetUrl)
      }
    }
  }, [location, destination, state, preserveQuery, external])

  // Show loading component if provided, otherwise empty fragment
  return loadingComponent || <></>
}

export default RedirectTemplate
